import { useEffect, useState } from "react";
import "./modal.css";
import { ModalProps } from "./modal.props";
import { Icon } from "../icon";
import { XMarkFill } from "../../assets";
import { useLanguage } from "../../hooks";

const Modal: React.FC<ModalProps> = ({
  title,
  open,
  onClose,
  setOpen,
  backdropClosable = true,
  children,
  className,
  titleStyles,
  actions,
}) => {
  const { t } = useLanguage();
  const handleClose = () => {
    onClose?.();
    setOpen(!open);
  };

  useEffect(() => {
    if (open) {
      // Bloquea el scroll
      document.body.style.overflow = "hidden";
    } else {
      // Restaura el scroll
      document.body.style.overflow = "";
    }

    // Limpieza por si el componente se desmonta mientras está bloqueado
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <div className={`modal-wrapper ${open ? "open" : "close"}`}>
        <div
          className="modal-backdrop"
          onClick={() => backdropClosable && handleClose()}
        />
        <div
          className={`modal-children ${className}`}
          style={{
            animation: `${open ? "modal-open" : "modal-close"} 0.3s forwards`,
          }}
        >
          <div className="modal-action-children-spacer">
            <div className="modal-action-header">
              {title !== undefined && title.length && (
                <h2
                  className={`modal-action-header-title ${
                    titleStyles?.className ?? ""
                  } content ${titleStyles?.contentAlign ?? "left"} textalign ${
                    titleStyles?.textAlign ?? "left"
                  }`}
                >
                  {title}
                </h2>
              )}

              <button
                className="modal-action-button-close"
                onClick={handleClose}
              >
                <Icon
                  icon={XMarkFill}
                  alt="Icon close (X)"
                  className="modal-action-button-close-icon"
                />
              </button>
            </div>
            {children}
          </div>

          {actions !== undefined && actions.length > 0 && (
            <div className="modal-actions-wrapper">
              {actions.map((act, i) => {
                return (
                  <button
                    className={`modal-action-button ${
                      i > 0 ? "modal-action-button-bl" : ""
                    } ${act.className} ${act.disabled ? "disabled" : ""}`}
                    key={`modal-action-${i}`}
                    onClick={(e) => {
                      e.preventDefault();
                      act.onClick?.();
                    }}
                    disabled={act.disabled}
                  >
                    {act?.type === "cancel"
                      ? t.components.modal.cancel
                      : act?.text ?? ""}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Modal;
